import Loading from './component/Loading'
import GlobalNav from './component/GlobalNav'
import NavItem from './component/NavItem'
import ThemeList from './component/ThemeList'
import MainVisual from './component/MainVisual'
import VideoPlayer from './component/VideoPlayer'
import BtnShare from './component/BtnShare'
import Top from './top/Top'
import ValidateForm from "./contact/ValidateForm";
import Hover from "./component/Hover";

//window.$ = jQuery.noConflict(true);

(function() {
  const requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame;
  window.requestAnimationFrame = requestAnimationFrame;
})();

class App
{
  // ---------------------------------------------------------------------------------------------------------
	// --	App
	// ---------------------------------------------------------------------------------------------------------

  constructor()
  {
    this.isReady = false
    $(document).ready(this.onReady.bind(this))

    this.isLoad = false
    $(window).on('load', this.onLoad.bind(this))
  }

  onReady()
  {
    //PAGEーTOPボタン
    $('.page-top').click(()=>{
      $('body, html').animate({ scrollTop: 0 }, 1000, 'easeInOutQuart')
    })

    //ローディング初期化
    this.loading = new Loading(this)
    // this.loading.once('COMPLETE', this.onLoad.bind(this))

    //グローバルナビ初期化
    new GlobalNav()

    //ナビゲーションアイテムの初期化
    new NavItem()

    //Bannerの初期化
    this.initSlick()

    //TOPの初期化
    if($('#top').length > 0) this.top = new Top()

    //テーマリストの初期化
    if($('.themes-list').length > 0) new ThemeList()

    //メインビジュアルの初期化
    if($('.detail-mv').length > 0) this.mv = new MainVisual()

    //フィルム詳細ページ
    if($('#video-player').length > 0) this.player = new VideoPlayer(G_MOVIE_SCRIPT)

    //フォーム入力ページ
    if($('#page-contact-fill').length > 0) new ValidateForm()

    new Hover()

    new BtnShare()

    const $someImages = $('.slide-item__bg img')
    objectFitImages($someImages)

    //フラグをたててスタート
    this.isReady = true

    this.start()
  }

  onLoad()
  {
    //フラグをたててスタート
    if (!this.isLoad) {
      this.isLoad = true
      this.start()
    }
  }

  start()
  {
    //console.log('start:' + this.isReady + '/' + this.isLoad)
    if(!this.isLoad || !this.isReady) return

    //ローディング消す
    this.loading.hide()

    //TOPスタート
    if(this.top) this.top.start()

    //メインビジュアルスタート
    if(this.mv) this.mv.start()

    // 動画プレイヤー設定
    if(this.player) this.player.start()
  }

  // ---------------------------------------------------------------------------------------------------------
	// --	SLICKの初期化
	// ---------------------------------------------------------------------------------------------------------

  initSlick()
  {
    //バナーを複製
    const cloneList = $('.banner__list').clone().html()
    for(let i=0; i<1; i++)
    {
      $('.banner__list').append(cloneList)
    }

    //Slickのセットアップ
    $('.banner__list').slick({
      dots: false,
      infinite: true,
      speed: 600,
      slidesToShow: 3,
      centerMode: true,
      variableWidth: true,
      initialSlide: 1,
      prevArrow: $('.banner__ui--prev'),
      nextArrow: $('.banner__ui--next')
    })
  }


	// ---------------------------------------------------------------------------------------------------------
}

$(function(){
  new App()
})